import SPINNER from '../assets/images/Spinner.gif';
import TIME_EXPIRED from '../assets/images/Icon_Time_Expired.svg';
// export Images
export const SPINNER_IMG = SPINNER;
export const TIME_EXPIRED_IMG = TIME_EXPIRED;
